import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ListWrapper = styled.ul`
  background: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: ${pxToRem(5)} ${pxToRem(15)};
  border-radius: 8px;
  -webkit-backdrop-filter: blur(${pxToRem(10)});
  backdrop-filter: blur(10px);
  box-shadow: 0 ${pxToRem(6)} ${pxToRem(20)} 0 rgba(160, 187, 255, 0.24);
  background-color: #fff;
`;

export const ItemWrapper = styled.li`
  padding: ${pxToRem(5)};
  border-radius: ${pxToRem(6)};
  width: ${pxToRem(28)};
  height: ${pxToRem(28)};
  text-align: center;
  background-color: ${props =>
    props.selected ? props.theme.colors.blue.five : ''};

  :hover {
    cursor: pointer;
  }
`;

export const PaginationData = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${pxToRem(8)} ${pxToRem(10)};
  margin-top: ${pxToRem(88)};
`;
export const PageSizeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DropDownContainer = styled.div`
  width: ${pxToRem(78)};
  display: flex;
  flex-direction: row;
`;

export const ResultsContainer = styled.div`
  width: ${pxToRem(150)};
`;

export const ShowMoreLess = styled.div`
  margin: 0 auto;
  display: flex;
  gap: ${pxToRem('200px')};
`;
